import React from 'react';
import styles from './CardTrainer.module.css';
import logoUsuarios from '../../Assets/logoUsuarios.png';

function formatoTelefono(numero) {
  if (!numero) return '';
  const limpio = numero.replace(/\D/g, '');
  if (limpio.length === 10) {
    return `(${limpio.slice(0,2)}) ${limpio.slice(2,6)}-${limpio.slice(6)}`;
  }
  if (limpio.length === 11) {
    return `(${limpio.slice(0,3)}) ${limpio.slice(3,7)}-${limpio.slice(7)}`;
  }
  return numero;
}

const CardTrainer = ({ trainer }) => (
  <div className={styles.row}>
    <div className={styles.cell}>
      <img
        src={trainer.profile_photo && trainer.profile_photo.trim() !== '' ? trainer.profile_photo : logoUsuarios}
        alt={trainer.name}
        className={styles.photo}
        onError={e => { e.target.onerror = null; e.target.src = logoUsuarios; }}
      />
    </div>
    <div className={styles.cell}>{trainer.name} {trainer.last_name}</div>
    <div className={styles.cell}>{trainer.dni}</div>
    <div className={styles.cell}>{trainer.email}</div>
    <div className={styles.cell}>
      <a href={`tel:${trainer.phone_number}`}>{formatoTelefono(trainer.phone_number)}</a>
    </div>
    <div className={styles.cell}>{trainer.specialty}</div>
    <div className={styles.cell}>{trainer.status ? <span style={{color:'green'}}>Activo</span> : <span style={{color:'red'}}>Inactivo</span>}</div>
  </div>
);

export default CardTrainer;